import { render, staticRenderFns } from "./RepairsTable.vue?vue&type=template&id=12187cac&scoped=true"
import script from "./RepairsTable.vue?vue&type=script&lang=js"
export * from "./RepairsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12187cac",
  null
  
)

export default component.exports